/* global modForm */
import { initQuadTransform } from '../../helpers';
/**
 * function to be called on site's window.load Event. Need to enable `modForm.opts.useQSApi` & `modForm.opts.delayQuadTransformation`.
 */
export function triggerQuadTransform() {
	if (modForm.opts.useQSApi && modForm.opts.delayQuadTransformation) {
		initQuadTransform(false);
	}
}
